export const TEXT_WAY_TO_GO = 'Way to go! You did such a great job on the last test, the researcher invited you to another test.';
